// extracted by mini-css-extract-plugin
module.exports = {"footer":"s_footer__XqZEV"};